/* eslint-disable no-nested-ternary */
import { Box, Tooltip } from '@mui/material';
import { IconChip } from '@product-framework/components/PageSection';
import { IconLibrary } from '@product-framework/index';
import { useLocalization } from '@ui-framework/index';

const NOT_AVAILABLE_SOURCES = ['LIVE_CALENDAR', 'SPECIAL_SCHEDULE'];

const labels = {
  SPECIAL_SCHEDULE: 'Special Schedule',
  LIVE_CALENDAR: 'Live Calendar',
};

function getRemovedSlotMessages(removedSlots) {
  return Object.entries(removedSlots).map(([source, slots]) => {
    const list =
      slots.length === 1
        ? slots[0]
        : slots.length === 2
          ? `${slots[0]} and ${slots[1]}`
          : `${slots.slice(0, -1).join(', ')} and ${slots.at(-1)}`;

    return `${list} slot${slots.length > 1 ? 's' : ''} ${slots.length > 1 ? 'were' : 'was'} removed by user on ${labels[source]}`;
  });
}

function SpecialScheduleInfo({ cellDateValue }) {
  const { formatMessage } = useLocalization();
  const customNotAvailableSchedules = cellDateValue?.slots
    ? cellDateValue?.slots?.reduce((acc, sl) => {
        if (
          sl?.blockedBy &&
          NOT_AVAILABLE_SOURCES.includes(sl?.blockedBy?.type) &&
          sl.available === false
        ) {
          return {
            ...acc,
            [sl.blockedBy.type]: [
              ...(acc[sl.blockedBy.type] || []),
              formatMessage({
                id: sl?.code?.toUpperCase(),
                defaultMessage: sl?.code,
              }),
            ],
          };
        }
        return acc;
      }, {})
    : {};

  const hasNotAvailableSchedules =
    Object.entries(customNotAvailableSchedules)?.length > 0;

  const messages = getRemovedSlotMessages(customNotAvailableSchedules);

  return hasNotAvailableSchedules ? (
    <Tooltip
      arrow
      placement="top"
      title={
        <Box sx={{ mt: 1, mb: 1 }}>
          {messages.map(m => (
            <Box key={m} sx={{ mb: 0.5 }}>
              {m}
            </Box>
          ))}
        </Box>
      }>
      <Box>
        <IconChip
          sx={{ pointerEvents: 'auto' }}
          size={15}
          iconFontSize={9}
          Icon={IconLibrary.SpecialSchedule}
          bgColor="warning.dark"
          iconColor="white"
        />
      </Box>
    </Tooltip>
  ) : null;
}

export default SpecialScheduleInfo;
